<div class="tro">

  <!-- Fejléc + szűrők -->
  <div class="tro-head">
    <div class="tro-head__text">
      <h1 class="stk-page-title">Tracking</h1>
      <div class="stk-page-sub">A kiküldött csomagok egy helyen: futár, állapot, hol tart, mikorra kell kiérnie. Zöld = rendben, sárga = figyelni kell, piros = baj van.</div>
    </div>
  </div>

  <div class="tro-controls">
    <div class="tro-tabs">
      <button type="button" class="tro-tab" *ngFor="let t of rangeTabs"
              [class.tro-tab--active]="range === t" (click)="setRange(t)">{{ t }}</button>
    </div>
    <div class="tro-dates" *ngIf="isCustom">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"></rect><line x1="3" y1="10" x2="21" y2="10"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="16" y1="3" x2="16" y2="7"></line></svg>
      <input type="date" [(ngModel)]="customFrom" (ngModelChange)="onCustomDateChange()">
      <span class="tro-dates__sep">–</span>
      <input type="date" [(ngModel)]="customTo" (ngModelChange)="onCustomDateChange()">
    </div>
    <div class="tro-search">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="21" y2="21"></line></svg>
      <input type="text" [(ngModel)]="q" (ngModelChange)="onSearchChange()" placeholder="Vevő neve, küldeménykód, rendelésszám…" autocomplete="off">
    </div>
    <div class="tro-select-wrap">
      <select class="tro-select" [(ngModel)]="carrier" (ngModelChange)="onCarrierChange()">
        <option *ngFor="let c of carrierOptions" [ngValue]="c">{{ c === 'Mind' ? 'Minden futár' : c }}</option>
      </select>
      <span class="tro-select-chevron">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
      </span>
    </div>
    <button type="button" class="tro-settings-btn" [disabled]="refreshingAll" title="Minden nyitott csomag lekérdezése a futártól most" (click)="refreshAll()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12 a8 8 0 1 1 -2.3 -5.7"></path><polyline points="20,4 20,10 14,10"></polyline></svg>
      {{ refreshingAll ? 'Frissítés…' : 'Összes frissítése' }}
    </button>
    <button type="button" class="tro-settings-btn" [class.tro-settings-btn--on]="settingsOpen" (click)="toggleSettings()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12,7 12,12 15.5,14"></polyline></svg>
      Szállítási idők
    </button>
  </div>

  <div class="stk-info-bar tro-refresh-note" *ngIf="refreshAllResult">{{ refreshAllResult }}</div>

  <!-- Szállítási idők szerkesztője: célország → min..max nap -->
  <div class="tro-settings stk-card" *ngIf="settingsOpen">
    <div class="tro-settings__head">
      <div>
        <div class="stk-section-title">Szállítási idő célországonként</div>
        <div class="tro-settings__sub">A várható érkezés = feladás napja + ennyi nap. Az Etsy csak a feladási határidőt adja, a kézbesítést innen számoljuk. Sorrend: az ország saját sora, utána „EU", végül „*".</div>
      </div>
      <button type="button" class="stk-btn stk-btn--ghost" (click)="addRule()">+ Új sor</button>
    </div>
    <table class="stk-table tro-rules">
      <thead>
        <tr><th>Célország</th><th></th><th>Min. nap</th><th>Max. nap</th><th></th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rules; let i = index">
          <td data-label="Célország"><input class="tro-rules__scope" type="text" [(ngModel)]="r.scope" maxlength="2" placeholder="US" [disabled]="r.scope === '*'"></td>
          <td class="tro-rules__name">{{ scopeLabel(r.scope) }}</td>
          <td data-label="Min. nap"><input class="tro-rules__num" type="number" min="0" [(ngModel)]="r.min_days"></td>
          <td data-label="Max. nap"><input class="tro-rules__num" type="number" min="0" [(ngModel)]="r.max_days"></td>
          <td class="tro-rules__del">
            <button type="button" class="stk-icon-btn" *ngIf="r.scope !== '*'" title="Sor törlése" (click)="removeRule(i)">✕</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="tro-settings__foot">
      <span class="tro-settings__err" *ngIf="rulesError">{{ rulesError }}</span>
      <span class="tro-settings__ok" *ngIf="rulesSavedAt && !rulesError">Mentve.</span>
      <button type="button" class="stk-btn" [disabled]="rulesSaving" (click)="saveRules()">{{ rulesSaving ? 'Mentés…' : 'Mentés' }}</button>
    </div>

    <div class="tro-backfill">
      <div>
        <div class="stk-section-title">Etsy kézbesítési idők a meglévő rendelésekre</div>
        <div class="tro-settings__sub">Az új rendeléseknél a szinkron automatikusan rögzíti az Etsy szállítási profil szerinti várható érkezést. A régebbiekre ez a gomb tölti vissza az elmúlt 90 napra — rendelésenként egy Etsy-hívás, eltarthat egy percig.</div>
        <div class="tro-settings__ok" *ngIf="backfillResult">{{ backfillResult }}</div>
      </div>
      <button type="button" class="stk-btn stk-btn--ghost" [disabled]="backfilling" (click)="runBackfill()">{{ backfilling ? 'Visszatöltés…' : 'Visszatöltés (90 nap)' }}</button>
    </div>
  </div>

  <!-- Összesítő csempék — kattintva szűrnek -->
  <div class="tro-kpis" *ngIf="!loadFailed">
    <button type="button" class="tro-kpi" [class.tro-kpi--on]="statusFilter === 'all'" (click)="setStatus('all')">
      <span class="tro-kpi__n">{{ summary.total }}</span><span class="tro-kpi__l">Küldemény · {{ rangeLabel }}</span>
    </button>
    <button type="button" class="tro-kpi tro-kpi--green" [class.tro-kpi--on]="statusFilter === 'green'" (click)="setStatus('green')">
      <span class="tro-kpi__n">{{ inTransitOk }}</span><span class="tro-kpi__l">Úton, rendben</span>
    </button>
    <button type="button" class="tro-kpi tro-kpi--yellow" [class.tro-kpi--on]="statusFilter === 'yellow'" (click)="setStatus('yellow')">
      <span class="tro-kpi__n">{{ summary.yellow }}</span><span class="tro-kpi__l">Figyelni kell</span>
    </button>
    <button type="button" class="tro-kpi tro-kpi--red" [class.tro-kpi--on]="statusFilter === 'red'" (click)="setStatus('red')">
      <span class="tro-kpi__n">{{ summary.red }}</span><span class="tro-kpi__l">Baj van</span>
    </button>
    <button type="button" class="tro-kpi tro-kpi--done" [class.tro-kpi--on]="statusFilter === 'delivered'" (click)="setStatus('delivered')">
      <span class="tro-kpi__n">{{ summary.delivered }}</span><span class="tro-kpi__l">Kézbesítve</span>
    </button>
  </div>

  <div class="tro-state" *ngIf="loadFailed">
    <div class="tro-state__title">A nyomkövetési adatok nem érhetők el</div>
    <div class="tro-state__sub">A szerver nem válaszolt — próbáld meg újra.</div>
    <button type="button" class="stk-btn stk-btn--ghost" (click)="load()">Újrapróbálás</button>
  </div>

  <div class="tro-state" *ngIf="loading && !loadFailed">
    <div class="tro-state__sub">Küldemények betöltése…</div>
  </div>

  <div class="tro-state" *ngIf="!loading && !loadFailed && !visible.length">
    <div class="tro-state__title">Nincs küldemény ebben a szűrésben</div>
    <div class="tro-state__sub">Válassz nagyobb időszakot, vagy vedd ki a szűrőt.</div>
  </div>

  <!-- Lista -->
  <div class="tro-list stk-card" *ngIf="!loading && !loadFailed && visible.length">
    <div class="tro-row tro-row--head">
      <span>Állapot</span>
      <span>Vevő</span>
      <span>Feladva</span>
      <span>Futár · kód</span>
      <span>Utolsó esemény</span>
      <span>Várható érkezés</span>
    </div>

    <div class="tro-row" *ngFor="let vm of visible; trackBy: trackByCode" [ngClass]="severityClass(vm.row.severity)" (click)="openOrder(vm.row)">

      <!-- Állapot: színes sáv + pill + ok -->
      <div class="tro-cell tro-cell--status">
        <span class="stk-pill" [ngClass]="pillClass(vm.row.severity)">{{ vm.row.statusLabel }}</span>
        <div class="tro-reason" *ngIf="vm.row.severityReason && vm.row.severityReason !== vm.row.statusLabel">{{ vm.row.severityReason }}</div>
        <div class="tro-badges">
          <span class="tro-badge tro-badge--pickup" *ngIf="vm.row.awaitingPickup">Átvevőponton</span>
          <span class="tro-badge tro-badge--late" *ngIf="vm.row.lateDays > 0">{{ vm.row.lateDays }} napja késik</span>
          <span class="tro-badge tro-badge--stalled" *ngIf="vm.row.stalledDays && vm.row.stalledDays >= 3 && !vm.row.deliveredAt">{{ vm.row.stalledDays }} napja nem mozdul</span>
          <span class="tro-badge" *ngIf="vm.row.kind === 'replacement'">Csere csomag</span>
        </div>
      </div>

      <!-- Vevő -->
      <div class="tro-cell">
        <div class="tro-name">{{ vm.row.customer || '—' }}</div>
        <div class="tro-sub">{{ vm.countryLabel }}<ng-container *ngIf="vm.row.shopName"> · {{ vm.row.shopName }}</ng-container></div>
        <div class="tro-sub">#{{ vm.row.receiptId || vm.row.orderNumber || vm.row.orderId }} · rendelve {{ vm.orderedLabel }}</div>
      </div>

      <!-- Feladva -->
      <div class="tro-cell" data-label="Feladva">
        <div class="tro-name" *ngIf="vm.shippedLabel">{{ vm.shippedLabel }}</div>
        <div class="tro-name tro-name--muted" *ngIf="!vm.shippedLabel">még nincs feladva</div>
        <div class="tro-sub" *ngIf="vm.transitLabel">{{ vm.transitLabel }}</div>
        <div class="tro-sub" *ngIf="!vm.shippedLabel && vm.row.shipByAt">határidő {{ fmtDate(vm.row.shipByAt) }}</div>
      </div>

      <!-- Futár + kód -->
      <div class="tro-cell" data-label="Futár · kód">
        <div class="tro-name">{{ vm.row.carrierName || 'Ismeretlen futár' }}</div>
        <a *ngIf="vm.row.trackingUrl" class="tro-code" [href]="vm.row.trackingUrl" target="_blank" rel="noopener" (click)="$event.stopPropagation()">{{ vm.row.trackingCode }} ↗</a>
        <div *ngIf="!vm.row.trackingUrl" class="tro-code">{{ vm.row.trackingCode }}</div>
      </div>

      <!-- Utolsó esemény -->
      <div class="tro-cell" data-label="Utolsó esemény">
        <ng-container *ngIf="vm.row.lastEventLabel; else noEvent">
          <div class="tro-name">{{ vm.row.lastEventLabel }}</div>
          <div class="tro-sub"><ng-container *ngIf="vm.row.lastEventLocation">{{ vm.row.lastEventLocation }} · </ng-container>{{ vm.lastEventTime }}</div>
        </ng-container>
        <ng-template #noEvent>
          <div class="tro-name tro-name--muted">még nincs esemény</div>
          <div class="tro-sub tro-sub--err" *ngIf="vm.row.pollError">{{ vm.row.pollError }}</div>
        </ng-template>
      </div>

      <!-- Várható érkezés -->
      <div class="tro-cell" data-label="Várható érkezés">
        <ng-container *ngIf="vm.row.deliveredAt; else estimate">
          <div class="tro-name">Kézbesítve {{ fmtDate(vm.row.deliveredAt) }}</div>
        </ng-container>
        <ng-template #estimate>
          <div class="tro-name" *ngIf="vm.estimateLabel" [class.tro-name--late]="vm.row.lateDays > 0">{{ vm.estimateLabel }}</div>
          <div class="tro-name tro-name--muted" *ngIf="!vm.estimateLabel">nincs adat</div>
          <div class="tro-sub" *ngIf="vm.estimateNote">{{ vm.estimateNote }}</div>
          <div class="tro-sub" *ngIf="vm.row.transitScope">{{ vm.row.transitScope === 'ETSY' ? 'Etsy szállítási profil' : (vm.row.transitScope === '*' ? 'alap szabály' : vm.row.transitScope + ' szabály') }}</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
